import { useFormik } from 'formik';
import React from 'react';
import { Input } from '../../Components/UI/Input';
import AlertModal from '../AlertModal';
import classes from './PinCodeModal.module.css';
import clsx from 'clsx';
import Button from '../../Components/UI/Button'; // Assuming you have a Button component
import { changePinCodeSchema } from '../../Schema';
import { useSelector } from 'react-redux';
import ModalAction from '../ModalAction';
const initialValues = {
  currentPinCode: '',
  newPinCode: '',
  confirmPinCode: ''
};

const PinCodeModal = ({ onSubmit, setShow, show, loading }) => {
  const currentPassword = useSelector((state) => state?.authReducer?.password);

  const formik = useFormik({
    initialValues,
    validationSchema: changePinCodeSchema,
    onSubmit: (values, { resetForm, setErrors }) => {
      if (values.currentPinCode !== currentPassword) {
        setErrors({ currentPinCode: 'Current pin code does not match' });
        return;
      }

      const params = { ...values };
      //   onSubmit(params, () => {
      //     setShow(false);
      //     resetForm();
      //   });
    }
  });

  const { touched, errors, values, handleSubmit, resetForm, setFieldValue, setFieldTouched } =
    formik;

  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  const onCancel = () => {
    setShow(false);
    resetForm();
  };

  const isDisabled =
    !values.currentPinCode ||
    !values.newPinCode ||
    !values.confirmPinCode ||
    Object.keys(errors).length > 0;

  return (
    <AlertModal title="Pin Code" show={show} setShow={setShow} actions={false}>
      <form onSubmit={handleSubmit}>
        <Input
          label="Current Pin Code"
          errorText={touched?.currentPinCode && errors?.currentPinCode}
          value={values?.currentPinCode}
          placeholder="Enter Current Pin Code"
          setter={(e) => handleChangeWithTouch('currentPinCode', e)}
          id="currentPinCode"
        />
        <Input
          label="New Pin Code"
          className={classes['mt-8px']}
          errorText={touched?.newPinCode && errors?.newPinCode}
          placeholder="Set New Pin Code"
          value={values?.newPinCode}
          setter={(e) => handleChangeWithTouch('newPinCode', e)}
          id="newPinCode"
        />
        <Input
          label="Confirm Pin Code"
          className={classes['mt-8px']}
          errorText={touched?.confirmPinCode && errors?.confirmPinCode}
          placeholder="Confirm Pin Code"
          value={values?.confirmPinCode}
          setter={(e) => handleChangeWithTouch('confirmPinCode', e)}
          id="confirmPinCode"
        />
        <ModalAction
          type="submit"
          disabled={isDisabled}
          isApiCall={loading}
          className={classes.actions}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
          }}
        />
      </form>
    </AlertModal>
  );
};

export default PinCodeModal;
